import type { ConversationColumnRef } from '@/shared/api';

/** Идентификатор фильтра списка диалогов по внешней выборке. Колонки у фильтра нет — пользователь его не заполняет. */
export const CONVERSATION_IDS_FILTER_ID = 'conversationIds';

/** Источники внешней выборки диалогов — показатели дашбордов. */
export const CONVERSATION_SELECTION_SOURCES = [
  'autoInsight',
  'qualityZone',
  'consultantRating',
  'criteriaAverage',
  'lowScore',
  'distribution',
  'trend',
  'alert',
  'customChart',
] as const;

/**
 * Источник внешней выборки — показатель дашборда, с которого она пришла. Определяет
 * автоматическое имя сохранённого пресета («Зона качества N. …», «Критерий N. …» и т. д.):
 * состав диалогов о своём происхождении ничего не говорит, а описание выборки — свободный
 * текст, поэтому источник обязан доехать до списка вместе с ней.
 */
export type ConversationSelectionSource = (typeof CONVERSATION_SELECTION_SOURCES)[number];

/**
 * Внешняя выборка диалогов: посчитанный снаружи список разговоров и его описание.
 * Доезжает до страницы списка диалогов состоянием навигации (переход в текущей вкладке)
 * либо через хранилище браузера по ключу в адресе (переход в новой вкладке).
 */
export type ConversationSelection = {
  /** Идентификаторы диалогов выборки */
  conversationIds: number[];
  /** Описание выборки — то, чем показатель подписан на дашборде (текст инсайта, ФИО, название критерия) */
  description: string;
  /** Источник выборки — определяет автоматическое имя сохранённого пресета */
  source: ConversationSelectionSource;
  /**
   * Колонки, по которым посчитан элемент дашборда, открывший выборку: они входят в вид слоя
   * выборки, а не в личный вид таблицы
   */
  columns?: ConversationColumnRef[];
};
